import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Stack, TagsInput, Text } from "@mantine/core";
import { AppModal } from "../../shared/AppModal";
import { isEmail, useForm, yupResolver } from "@mantine/form";
import { AlternateEmailOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { useCreatePriorityReferralMutation } from "../../graphql/graphql";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
import { PriorityReferralInitialValues, PriorityReferralSchema } from "./PriorityReferralModal.validation";
export const PriorityReferralModal = ({ priorityEntryId, opened, close }) => {
    // Form Data
    const form = useForm({
        mode: "controlled",
        initialValues: PriorityReferralInitialValues,
        validate: yupResolver(PriorityReferralSchema)
    });
    // Mutations
    const [{ fetching: createFetching }, createPriorityReferral] = useCreatePriorityReferralMutation();
    const submitPriorityReferral = async (event) => {
        event.preventDefault();
        // Set the priority entry id in the form
        form.setFieldValue("priorityEntryId", priorityEntryId);
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        const formValues = form.getValues();
        createPriorityReferral({
            input: {
                referralRecipientEmails: formValues.referredEmails,
                priorityEntryId: priorityEntryId
            }
        })
            .then((data) => {
            const success = !!data.data?.priorityReferrals?.createPriorityReferral
                ?.success;
            if (success) {
                showSuccessNotification("Referral sent! You will be notified when the primary contact responds.");
            }
            else {
                showErrorNotification("An error occurred, the referral was not created.");
            }
        })
            .catch((error) => {
            console.error("An error occurred.", error);
            showErrorNotification("An error occurred, the referral was not created.");
        })
            .finally(() => {
            handleClose();
        });
    };
    const handleClose = () => {
        form.reset();
        close();
    };
    return (_jsx(AppModal, { title: "Send Referral", opened: opened, onClose: handleClose, children: _jsxs(Stack, { style: { gap: "1rem" }, children: [_jsx(TagsInput, { variant: "pill", maxTags: 10, label: "Emails To Send Referral To", placeholder: "You can add multiple emails here...", leftSection: _jsx(SvgIcon, { fontSize: "inherit", component: AlternateEmailOutlined }), clearable: true, acceptValueOnBlur: true, splitChars: [",", " "], ...form.getInputProps("referredEmails"), onChange: (values) => {
                        form.setFieldValue("referredEmails", values
                            .filter((email) => email.trim() !== "" && isEmail(email))
                            .map((email) => email.trim().toLowerCase()));
                    } }), _jsx(Text, { variant: "paragraph", ta: "center", style: {
                        padding: "12px 16px",
                        backgroundColor: "var(--mantine-color-blue-0)",
                        border: "1px solid var(--mantine-color-blue-3)",
                        color: "var(--mantine-color-blue-9)",
                        borderRadius: "8px",
                        lineHeight: 1.5
                    }, children: "After submitting this referral, the primary contact will receive an email notification. Once they approve the referral, emails will be automatically sent to the selected organizations to complete the referral process." }), _jsx(Flex, { justify: "flex-end", children: _jsx(Button, { variant: "filled", loading: createFetching, onClick: submitPriorityReferral, children: "Send Referral" }) })] }) }));
};
